import { useDispatch, useReduxState } from 'hooks';
import api from 'api';
import { actions } from 'store';
import { ModalButtonWithForm } from 'components/common';
import { SelectAdmin } from 'components/common/admins';
import { FormGroup } from 'components/common/form';

import type { AdminGroupUpdateUsers } from './AdminGroup';

interface Props {
  addedUserIds: number[];
  updateUsers: (obj: AdminGroupUpdateUsers) => Promise<void>;
}

const AdminGroupUsersAdd = ({ addedUserIds, updateUsers }: Props) => {
  const { dispatch } = useDispatch();

  const {
    messages,
    pageState: { adminGroupId }
  } = useReduxState();

  const handleSubmit = async (values) => {
    try {
      await api.post(`/admin/admin-groups/${adminGroupId}/users`, {
        userIds: values.userIds.map((value) => value.userId)
      });
      await updateUsers({ page: 1, search: '', sortBy: '' });
      dispatch(
        actions.addNotice({
          text: messages.commonAddUsersSuccess,
          type: 'success'
        })
      );
    } catch (err) {
      await dispatch.handleErrorDispatch(err);
    }
  };

  return (
    <ModalButtonWithForm
      buttonCategory="success"
      buttonIcon="plus"
      buttonSize="header"
      buttonText={messages.commonAddUsers}
      modalActionText={messages.commonAdd}
      modalTitle={messages.commonAddUsers}
      modalWidth="medium"
      onSubmit={handleSubmit}
      pristineIsValid={false}
    >
      {(formState) => (
        <FormGroup label={messages.emailAddresses} maxWidth="100%">
          <SelectAdmin
            error={formState.errors.userIds}
            existingUserIds={addedUserIds}
            field="userIds"
            isMulti={true}
            isRequired={true}
            searchParams="&role=admin"
          />
        </FormGroup>
      )}
    </ModalButtonWithForm>
  );
};

export default AdminGroupUsersAdd;
